const overviewItems = [
  { label: '会社名', value: '株式会社BotaN' },
  { label: '代表取締役', value: '永末紗羅' },
  { label: '設立', value: '2025年12月' },
  { label: '所在地', value: '〒810-0075 福岡県福岡市中央区港1-2-18-1712' },
  { label: '電話番号', value: '092-577-9739' },
  { label: 'メールアドレス', value: 'info@botan-buy.com' },
  { label: '資本金', value: '200万円' },
  { label: '取引銀行', value: '三井住友銀行' },
  { label: '許認可', value: '古物商 福岡県公安委員会 901012610013' },
];

export default function CompanyOverview() {
  return (
    <section id="company" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-primary font-medium uppercase mb-3">Company</span>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-4">会社概要</h2>
          <div className="w-16 h-0.5 bg-primary/30 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[440px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/730f0eb9f72eb288a3c7192ebbe490cc.jpg"
                alt="株式会社BotaN"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Accent card */}
            <div className="absolute -bottom-6 -right-6 bg-primary text-white rounded-2xl p-6 shadow-lg w-44">
              <p className="text-3xl font-serif font-semibold">2025</p>
              <p className="text-xs text-white/70 mt-1">年設立</p>
              <div className="mt-3 w-8 h-0.5 bg-white/40"></div>
              <p className="text-xs text-white/70 mt-2">信頼と実績</p>
            </div>
          </div>

          {/* Info Table */}
          <div>
            <p className="text-gray-600 text-sm leading-relaxed mb-8">
              株式会社BotaNは、福岡市を本拠地として、買取専門店「天神屋」と
              カードショップ「まんがく」の2事業を展開しております。
              専門知識と公正な査定で、お客様の大切なお品物を適正価格で評価することを
              お約束します。
            </p>
            <div className="flex flex-col divide-y divide-gray-100">
              {overviewItems.map((item) => (
                <div key={item.label} className="flex py-4 gap-6">
                  <dt className="text-xs font-semibold text-primary/70 tracking-wide w-28 flex-shrink-0 pt-0.5">
                    {item.label}
                  </dt>
                  <dd className="text-sm text-gray-700 flex-1">{item.value}</dd>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
